import { Directive, ElementRef, Host, HostListener, Input, Self } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { AssistantService } from '../common/assistant.service';

/**
 * Direktive, die das zuletzt fokussierte Eingabefeld für den Assistenten abspeichert, um so beim Aufruf des Assistenten
 * zu wissen, welches Feld fokussiert werden soll.
 */
@Directive({
  selector: '[appSaveLastFocussedConditionally]'
})
export class SaveLastFocussedConditionallyDirective {

  @Input() saveLastFocussedEnabled: boolean;

  @HostListener('focus') saveLastFocussedElement() {
    if (this.saveLastFocussedEnabled) {
      this.assistantService.setLastFocusedFormField({ field: <HTMLElement>this.elementRef.nativeElement, popoverForField: this.popoverForField });
    }
  }

  constructor(private assistantService: AssistantService,
              private elementRef: ElementRef,
              @Self() @Host() private popoverForField: NgbPopover) {
  }
}
